var map = {
	"./ic_aave_24.svg": 404,
	"./ic_arbitrum_24.svg": 405,
	"./ic_avalanche_24.svg": 406,
	"./ic_avax_24.svg": 407,
	"./ic_btc_24.svg": 408,
	"./ic_busd_24.svg": 409,
	"./ic_dai_24.svg": 410,
	"./ic_equity_24.svg": 411,
	"./ic_eth_24.svg": 412,
	"./ic_fantom_24.svg": 413,
	"./ic_frax_24.svg": 414,
	"./ic_ftm_24.svg": 415,
	"./ic_glp_24.svg": 416,
	"./ic_gmx_24.svg": 417,
	"./ic_link_24.svg": 418,
	"./ic_matic_24.svg": 419,
	"./ic_mim_24.svg": 420,
	"./ic_mvlp_24.svg": 421,
	"./ic_polygon_24.svg": 422,
	"./ic_tether_24.svg": 423,
	"./ic_uni_24.svg": 424,
	"./ic_usdc.e_24.svg": 425,
	"./ic_usdc_24.svg": 426,
	"./ic_usdt_24.svg": 427,
	"./ic_wallet_24.svg": 238,
	"./ic_wavax_24.svg": 428,
	"./ic_weth_24.svg": 429,
	"./ic_wftm_24.svg": 430,
	"./ic_wmatic_24.svg": 431
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 929;